module.exports = __webpack_public_path__ + "img/cs-protrain-7.2219ad2c.jpg";